import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initReviewsSlider = () => {
  const slider = document.querySelector("[data-reviews-slider]");
  if (!slider) return;

  new Swiper(slider, {
    lazy: true,
    watchOverflow: true,
    speed: 700,
    breakpoints: {
      0: {
        spaceBetween: 23,
        slidesPerView: 1,
      },
      768: {
        spaceBetween: 20,
        slidesPerView: 3
      }
    },
    pagination: {
      el: slider.querySelector(".swiper-pagination"),
      type: "fraction",
    },
    navigation: {
      nextEl: slider.querySelector(".slider-navigation__button--next"),
      prevEl: slider.querySelector(".slider-navigation__button--prev"),
    },
  });
};

export default initReviewsSlider;
